import React from 'react';
import { Disc3 } from 'lucide-react';

interface AnimatedDiscProps {
  size?: 'sm' | 'md' | 'lg';
  spin?: boolean;
  hoverSpin?: boolean;
  variant?: 'primary' | 'secondary' | 'accent';
  className?: string;
  label?: string;
}

const SIZE_PX = { sm: 20, md: 32, lg: 48 } as const;
const VARIANT_COLORS = {
  primary: 'text-primary-600 dark:text-primary-400',
  secondary: 'text-secondary-600 dark:text-secondary-400',
  accent: 'text-accent-dark dark:text-accent-light',
} as const;

const AnimatedDisc: React.FC<AnimatedDiscProps> = ({
  size = 'md',
  spin = false,
  hoverSpin = false,
  variant = 'primary',
  className = '',
  label,
}) => {
  const px = SIZE_PX[size];
  const colorCls = VARIANT_COLORS[variant];
  const spinCls = spin
    ? 'animate-[spin_20s_linear_infinite] motion-reduce:animate-none'
    : hoverSpin
      ? 'group-hover:animate-[spin_20s_linear_infinite] motion-reduce:animate-none'
      : '';

  const a11yProps = label
    ? { role: 'img' as const, 'aria-label': label }
    : { 'aria-hidden': true as const };

  return (
    <span
      className={`relative inline-flex items-center justify-center vinyl-ring rounded-full ${className}`}
      style={{ width: px, height: px }}
      {...a11yProps}
    >
      <Disc3
        size={Math.floor(px * 0.8)}
        className={`${colorCls} ${spinCls} transition-transform`}
        strokeWidth={1.75}
      />
    </span>
  );
};

export default AnimatedDisc;
